<template>
  <el-card style="margin-top: 20px">
    <div  class="title" >
      <p class="title1">西南交通大学继续教育学院成绩单</p>
      <p style="margin-bottom: 10px">
        <span>学号:{{userInfo.student_id}}</span>
        <span style="margin-left: 10px">姓名:{{userInfo.name}}</span>
      </p>
    </div>
    <el-table
        :data="tableData.scoreList"
        style="width: 100%"
        row-key="id"
        size="mini"
        border
        lazy
        :tree-props="{ children: 'children', hasChildren: 'sublayer' }"
        :header-cell-style="{ background: '#f7f2f2', color: '#606266' }"
    >
      <el-table-column prop="course_code" label="课程代码"  align="center" width="100" />
      <el-table-column prop="course_name" label="课程名称" align="center"></el-table-column>
      <el-table-column prop="point" label="学分" align="center" width="100"></el-table-column>
      <el-table-column prop="total_score" label="总成绩" width="150" align="center"> </el-table-column>
      <el-table-column prop="usual_performance" label="平时成绩" width="150" align="center"> </el-table-column>
      <el-table-column prop="teacher" label="教师" width="150" align="center"> </el-table-column>
      <el-table-column prop="term" label="考试学期" width="200" align="center"> </el-table-column>
      <el-table-column prop="memo" label="备注" width="150" align="center"> </el-table-column>
    </el-table>
    <div style="background: #f7f2f2">
      <p style="text-align: center;line-height: 30px;font-size: 20px">平均成绩:{{userInfo.avg_mark}}</p>
      <p style="text-align: center;line-height: 30px">(平均成绩不含考查课、!毕业设计或毕业论文以及其他毕业实践环节，旨在为学生申请优秀毕业生或本科学生申请学位提供依据)</p>
    </div>
    </el-card>

</template>
<script setup>
import {ref} from "vue";
import {getStudentAvgMark, getStudentScore, getuserinfo} from "../../../api/mine";

const tableData = ref({})

getStudentScore().then(data=>{
  tableData.value = data.datas;
})
const userInfo = ref({})
getStudentAvgMark().then(data=>{
  userInfo.value=data.datas
})

</script>
<style lang="scss" scoped>
.title{
  text-align: center;
  .title1{
    font-size: 20px;
    line-height: 50px;
  }
}

</style>

